import { Button, Modal, Select } from "antd";

export default function RemoveAccessGroupTag({ props }) {
  return (
    <>
      <div className={"pb-3 pr-2 wfit"}>
        <Button type="primary" onClick={props.toggleVisibilityRemoveTag}>
          Delete Tag
        </Button>

        <Modal
          visible={props.visibilityRemoveTag}
          title="Delete Tag"
          onOk={props.toggleVisibilityRemoveTag}
          onCancel={props.toggleVisibilityRemoveTag}
          footer={[
            <Button key="back" onClick={props.toggleVisibilityRemoveTag}>
              Return
            </Button>,
            <Button
              type="primary"
              key="submit"
              className={"btn btn-success"}
              loading={props.loading}
              onClick={props.removeTag}
            >
              Delete
            </Button>,
          ]}
        >
          <div className="p-2">
            <span> Tagging Name</span>
            <Select
              showSearch
              value={props.taggingID || null}
              onChange={(e) => props.setTaggingID(e)}
              size="default"
              placeholder={"Select Tagging Name"}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              className="w-100percent ant-input mw-150"
            >
              {props.taggings?.map((mode, index) => (
                <Option value={mode.id} key={index}>
                  {mode.tagging_name}
                </Option>
              ))}
            </Select>
          </div>
        </Modal>
      </div>
    </>
  );
}
